import { FeatureFlagClient } from './feature-flag-client'

/**
 * Push data to the feature flag tracking system
 * @param metricName - Name of the metric
 * @param data - Data to push
 */

export const track = (metricName: string, data?: Record<string, unknown>) => {
  try {
    FeatureFlagClient.getClient()?.track(metricName, data)

    const isDebugEnabled = localStorage?.getItem('debugDataLayer') === 'true'
    if (isDebugEnabled) {
      console.groupCollapsed(
        `%c[Feature Flag Track] ${metricName}`,
        'color: #4CAF50; font-weight: bold'
      )
      console.log(data)
      console.groupEnd()
    }
  } catch (e) {
    console.warn('Failed to track Feature flag metric', e)
  }
}

/**
 * Main tracking object for metric and events related to feature flags and experiments
 */

export const FeatureFlagTracker = {
  /**
   * Track a metric in LaunchDarkly for experiments
   *
   * @param metricName - Name of the metric
   * @param data - Data to be sent
   */
  trackEvent: (metricName: string, data?: Record<string, unknown>) => {
    track(metricName, data)
  }
}
